import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors } from "@ryde/theme";

import { TableAvailabilityStyled } from "../table-availability-template/table-availability.styled";

// Same look as the other multi-row templates (one control per row, 110px label column); only the additions below differ.
export const CatchARideAvailabilityStyled = styled(
  TableAvailabilityStyled,
).attrs<IStyledAttributes>({
  "data-e2e": "catch-a-ride-availability",
})`
  .availability__container .availability-item {
    &__label {
      color: ${greyMui._600};
      line-height: 1.8;
    }

    &__hint {
      color: ${greyMui._600};
      font-size: 0.85em;
    }
  }

  .availability__container button.add_button:focus-visible,
  .availability__container .availability-item__buttons button:focus-visible {
    outline: 2px solid ${rydeColors.focusedControl};
    outline-offset: 2px;
  }

  .catch-a-ride-availability__description {
    margin: -8px 0 12px;
    color: ${greyMui._600};
    font-size: 0.9em;
    line-height: 1.5;
  }

  @media (prefers-reduced-motion: reduce) {
    .availability__container .availability-item,
    .availability__container button.add_button {
      transition: none;
    }
  }
`;
